import React, {useState} from 'react';
import Span from "./span";

function DataFieldItem ({label, value, onKeyDownEnter, className="text-xs", placeholder, longText, disabled = false}){
    const [focused, setFocused] = useState(false);
    const hasValue = value !== null && value !== undefined && value !== "";
    const safeValue = value ?? "";

    return(
        <div className="text-xs flex align-items-center">
            {label&&<span>{label}:</span>}
            <Span placeholder={placeholder} focused={focused} type={longText&&"LONG_TEXT"} inputClassName={`${className} surface-50`} spanClassName={`${className} p-1 ${!hasValue ? "text-400" : ""}`} setFocused={disabled ? undefined : setFocused} inputValue={safeValue} onKeyDownEnter={disabled ? undefined : onKeyDownEnter}>{hasValue ? value : placeholder}</Span>
        </div>
    )
}

export default DataFieldItem;
